import useDebugStore from '../hooks/useDebugStore';
import { CONFIG } from '../constants/config';

/**
 * Intercepts global fetch calls to log network activity to the Debug Store.
 */
export const initNetworkInterceptor = () => {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    // Check if we should log this request
    if (!CONFIG.IS_DEV_OR_DEBUG) {
      return originalFetch(...args);
    }

    const id = Math.random().toString(36).substr(2, 9);
    const url = args[0];
    const options = args[1] || {};
    const method = options.method || 'GET';
    const startTime = performance.now();

    // Log the request
    useDebugStore.getState().addNetworkLog({
      id,
      url,
      method,
      requestHeaders: options.headers,
      requestBody: options.body,
      status: 'pending',
    });

    try {
      const response = await originalFetch(...args);
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(0);

      // Clone response to read body without consuming it
      const clonedResponse = response.clone();
      let responseBody;
      const contentType = clonedResponse.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        try {
          responseBody = await clonedResponse.json();
        } catch (e) {
          responseBody = '[Error parsing JSON]';
        }
      } else {
        responseBody = '[Non-JSON response]';
      }

      // Update log with response
      useDebugStore.getState().updateNetworkLog(id, {
        status: response.status,
        statusText: response.statusText,
        duration: `${duration}ms`,
        responseBody,
        responseHeaders: Object.fromEntries(clonedResponse.headers.entries()),
      });

      return response;
    } catch (error) {
      const endTime = performance.now();
      const duration = (endTime - startTime).toFixed(0);

      useDebugStore.getState().updateNetworkLog(id, {
        status: 'failed',
        duration: `${duration}ms`,
        error: error.message,
      });

      throw error;
    }
  };
};
